import { humanizeEnum } from '@/utils/format'

/**
 * Single source of truth mapping every status/severity enum used across the
 * app (JobStatus, JobApplicationStatus, ExportStatus, MembershipStatus,
 * SecurityEventSeverity, UserStatus) to a Bootstrap/Zynix badge color.
 */
const STATUS_COLOR_MAP: Record<string, string> = {
  // Job status
  draft: 'secondary',
  published: 'success',
  paused: 'warning',
  closed: 'danger',
  archived: 'dark',
  // Job application status
  applied: 'info',
  under_review: 'warning',
  shortlisted: 'primary',
  hired: 'success',
  rejected: 'danger',
  withdrawn: 'secondary',
  // Organization status (pending / rejected shared with the entries around it)
  approved: 'success',
  hold: 'warning',
  blacklisted: 'dark',
  // Export status
  queued: 'secondary',
  processing: 'info',
  completed: 'success',
  failed: 'danger',
  expired: 'dark',
  // Membership / account status
  active: 'success',
  inactive: 'secondary',
  pending: 'warning',
  blocked: 'danger',
  pending_verification: 'warning',
  // Candidate task status
  done: 'success',
  // Security event severity
  low: 'info',
  medium: 'warning',
  high: 'danger',
  critical: 'dark',
}

interface StatusPillProps {
  status: string
  className?: string
}

export function StatusPill({ status, className = '' }: StatusPillProps) {
  const color = STATUS_COLOR_MAP[status] ?? 'secondary'

  return (
    <span className={`badge bg-${color}-transparent ${className}`.trim()}>
      {humanizeEnum(status)}
    </span>
  )
}
